import {FC} from 'react';
import {EventRoute} from '../eventRoutes';
import {RouteHeader} from '../routeHeader/routeHeader';
import {RouteDropdown} from './routeDropdown';
import {useIsMobile} from '@/hooks/useIsMobile';

interface RouteSelectorProps {
  routes: EventRoute[];
  onClick: (routeId: string) => void;
  activeRoute: EventRoute;
}

export const RouteSelector: FC<RouteSelectorProps> = ({
  activeRoute,
  routes,
  onClick,
}) => {
  const isMobile = useIsMobile();
  return (
    <div className="flex flex-1">
      {routes.length <= 3 && !isMobile ? (
        <>
          {routes.map((route) => (
            <RouteCard
              key={route.id}
              route={route}
              isSelected={route.id === activeRoute.id}
              onSelect={() => onClick(route.id)}
            />
          ))}
        </>
      ) : (
        <RouteDropdown
          routes={routes}
          activeRoute={activeRoute}
          onSelect={onClick}
        />
      )}
    </div>
  );
};

/** Individual route card that fills available space. */
function RouteCard({
  route,
  isSelected,
  onSelect,
}: {
  route: EventRoute;
  isSelected: boolean;
  onSelect: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`flex-1 flex items-start min-w-0 text-left border first:rounded-l-lg first:border-r-none last:rounded-r-lg last:border-l-none p-4 transition-colors cursor-pointer ${
        isSelected
          ? 'border-b-3 border-b-primary-500 bg-primary-100/20'
          : 'border-neutral-200 hover:border-neutral-300'
      }`}
    >
      <RouteHeader route={route} />
    </button>
  );
}
